import { NotificationManager, PaymentV2Api } from '@atlas/core';

export const displayWithdrawalSuccessNotification = ({
  amount,
  currency,
  extraData = {},
  paymentMethod,
  response,
}) => {
  NotificationManager.display({
    data: {
      amount,
      currency,
      paymentMethod,
      publicPaymentId: response?.publicPaymentId,
      ...extraData,
    },
    message: 'withdrawalSuccessful',
    type: 'withdrawalSuccessful',
  });
};

export const submitWithdrawal = async ({ amount, currency, paymentMethod, requestData }) => {
  const response = await PaymentV2Api.createAsyncWithdrawalV2(requestData);

  displayWithdrawalSuccessNotification({ amount, currency, paymentMethod, response });

  return response;
};

export const showWithdrawalError = () => {
  NotificationManager.display({
    data: {
      headerTitle: 'withdrawal',
      title: 'failed_sad_emoticon',
    },
    type: 'error',
  });
};
